module.exports = __webpack_public_path__ + "static/media/bg.a06c1ff7.jpg";